// extracted by mini-css-extract-plugin
export var paginationContainer = "_8l-0";